<template>
  <v-btn
    v-if="!excelButtonDisabled"
    flat
    color="#2E7D32"
    class="UXdownload"
    :loading="isExcelDownloading"
    :disabled="disabled || isExcelDownloading"
    @click="excelDownload"
  >
    <img src="//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/uxicon-excel.png" /> Excelのエクスポート
    <span class="loadTxt" slot="loader">DownLoading...</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    excelDownload: Function,
    isExcelDownloading: Boolean,
    excelButtonDisabled: Boolean,
    disabled: Boolean
  },
  data: () => ({
    excelDownloading: false
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/button/excelDownloadButton.vue